const benefitTypes = {
  FIRST_RELOAD: "FIRST_RELOAD",
  MORE_INTERNET: "MORE_INTERNET",
  FLEX: "FLEX",
  NEW_CHIP: "NEW_CHIP",
  PAY: "PAY",
  PROMO_10GB: "PROMO_10GB",
};

export default benefitTypes;
